/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2023-05-08 13:30:38
 */

 import FeedbackOpinion from "../feedbackOpinion";
 import {Toast} from "src/util/toast";
 import {default as CellOperate} from "src/components/agGridComponent/cellOperate";
 import {IconBtnItem} from "src/components/iconBtnGroup/iconBtnGroup";
 import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
 import FeedbackOpinionApi,{FeedbackOpinionDOI} from "../api/feedbackOpinionApi";
 import _ from 'lodash'
 import ListPageService from 'src/types/ListPage';
 import override from "src/dectorators/override";
 import {QueryFormVOI} from "src/components/queryForm/queryForm";
 import Input from 'src/types/iview/Input';
 import EnumOperates from 'src/enums/enumOperates';
 
 export default class FeedbackOpinionService extends ListPageService {
     ctx: FeedbackOpinion;
 
     constructor (ctx: FeedbackOpinion) {
         super()
         this.ctx = ctx
     }
 
     @override
     createColumns (): ColDefCustom [] {
         let t = this
         return [
             {
                 headerName: '时间',
                 field: 'create_time',
                 minWidth: 170,
                 maxWidth: 170
             },
             {
                 headerName: '用户名称',
                 field: 'user_name',
                 minWidth: 170,
                 maxWidth: 170
             },
             {
                 headerName: '账号',
                 field: 'mobile',
                 minWidth: 170,
                 maxWidth: 170
             },
             {
                 headerName: '内容',
                 field: 'feedback_content',
                 minWidth: 1000,
                //  maxWidth: 1000
             },
         ]
     }
 
     @override
     creatQueryForm(): QueryFormVOI.DateItemType[] {
         return [
             
             {
                 component: Input,
                 width: 400,
                 label: '',
                 labelWidth:0,
                 field: 'keyword',
                 props: { value: '', placeholder: '请输入用户名称/账号/反馈内容' },
             },
         ];
     }
 
     @override
     initSearchParams (): void {
         this.ctx.searchParams = this.ctx.queryForm.getQueryObj<FeedbackOpinionDOI.QueryRowDataParamsI>()
         this.ctx.currentPage = 1
     }
 
     @override
     async searchTable () {
         let ctx = this.ctx
         let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
         ag.showLoading()
         let {code, data} = await FeedbackOpinionApi.searchList({
             ...ctx.searchParams,
             page_size: ctx.pageSize,
             page_index: ctx.currentPage
         })
         ag.hideLoading()
 
         if (code === 0) {
             ctx.rowData = data.data_info || []
             ctx.total = data.page_count
         }
     }
 
 }